import type {
  CartItems,
  CartItem,
} from 'hb-react/shared/components/ShoppingCard/hooks/v2';

export const findCartItem =
  <T extends CartItems>(
    lineItemableId: CartItem<T>['line_itemable_id'],
    lineItemableType: CartItem<T>['line_itemable_type'],
  ) =>
  (item: CartItems): item is T =>
    'line_itemable_type' in item &&
    item.line_itemable_id === lineItemableId &&
    item.line_itemable_type === lineItemableType;
